import { useEffect } from 'react';
import { MD5, SHA256 } from 'crypto-js';
import { decodeStorage } from 'functions/storageBase64'
import { repareTextDlayer } from 'newFunctions/repareDataService';
import { META_CODE } from 'constants/env';

const configureFacebook = (profileData, metaId, hashedEmailMeta) => {
  
    try{
      if(profileData?.correo){
        window.fbq('init', metaId, {
          em: hashedEmailMeta,
          fn: profileData?.nombre !== '' ? repareTextDlayer(profileData?.nombre) : '',
          ln: profileData?.apellidoP !== '' ? repareTextDlayer(profileData?.apellidoP) : '',
          ge: profileData?.genero !== '' ? profileData?.genero : '',
          db: profileData?.cumpleanios !== '' && profileData?.cumpleanios != null ? profileData?.cumpleanios.replace(/\-/ig, '') : '',
          external_id: profileData?.idClaro,
          country: 'mx'
        });
      }else{
        window.fbq('init', metaId);
      }
    }catch(e){}
  
  };
  


export function usePixeles(eventType, data){

  const profileData     = decodeStorage('profileData');    
  const metaId          = META_CODE;  
  const hashedEmailMeta = SHA256(profileData?.correo).toString();
  
  

  useEffect(() => {
    let onLoadPixeles = {};

    const scriptFacebook = document.createElement('script');
    scriptFacebook.type = 'text/javascript';
    scriptFacebook.async = true;
    scriptFacebook.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.body.appendChild(scriptFacebook);

    
    onLoadPixeles = () => {
      // console.log("onload pixeles meta:", metaId, " pinter: ", printerestId)
      switch (eventType) {
        case 'event_home':          
          // meta                    
          // console.log(" inicia meta!!!!!!!!", profileData)          
          // console.log(" inicia meta 2222", metaId)          
          try{            
            configureFacebook(profileData, metaId, hashedEmailMeta);
            window.fbq('track', 'PageView');
          }catch(e){
            console.log('error meta ****: ', e)
          }
          break;
                
        default:
          break;
      }
    };
    
    scriptFacebook.addEventListener('load', onLoadPixeles);

    return () => {   
      try{
        scriptFacebook.removeEventListener('load', onLoadPixeles);      
      }catch(e){
        console.log(e)
      }
      document.body.removeChild(scriptFacebook);
    };
  }, [eventType,data]);


}


